import * as ActionType from '../constants/ActionType'
import * as api from '../api/api';
import { push } from 'react-router-redux';

/**
 * Action creators
 **/

export function requestDocumentStorages() {
    return {
        type: ActionType.REQUEST_DOCUMENT_STORAGES
    }
}

function receiveDocumentStorages(json) {
    return {
        type: ActionType.RECEIVE_DOCUMENT_STORAGES,
        payload: json.items // TODO ... change if pagination is binded
    }
}

export function getDocumentStorages() {
    return (dispatch, getState) => {
        if ( areDocumentStoragesLoaded(getState()) ) {
            // Let the calling code know there's nothing to wait for.
            return Promise.resolve();
        } else {
            // Dispatch a thunk from thunk!
            return dispatch(fetchDocumentStorages());
        }
    };
}

function areDocumentStoragesLoaded(globalState) {
    return globalState.documentStorage.loaded;
}

// @see : http://redux.js.org/docs/advanced/AsyncActions.html
export function fetchDocumentStorages() {

    // Thunk middleware knows how to handle functions.
    // It passes the dispatch method as an argument to the function,
    // thus making it able to dispatch actions itself.

    return function (dispatch, getState) {

        // First dispatch: the app state is updated to inform
        // that the API call is starting.

        dispatch(requestDocumentStorages())

        // The function called by the thunk middleware can return a value,
        // that is passed on as the return value of the dispatch method.

        // In this case, we return a promise to wait for.
        // This is not required by thunk middleware, but it is convenient for us.
        api.getDocumentStorages()
            .then(function(response) {
                return api.handleStatus(response, dispatch)
            })
            .then(json =>
                // We can dispatch many times!
                // Here, we update the app state with the results of the API call.
                dispatch(receiveDocumentStorages(json))
            )
        // .catch(error => {
        //     console.log(`Request failed: ${error}`);
        // })
        ;

        // In a real world app, you also want to
        // catch any error in the network call.
    }
}

export function createDocumentStorage(title, documentId, locale, pricingField, redirectToConfigurator = false) {
    console.log('createDocumentStorage');
    console.log('pricingField');
    console.log(pricingField);
    return (dispatch, getState) => {

        dispatch(requestDocumentStorage());

        api.createDocumentStorage(title, documentId, locale, pricingField)
            .then(function(response) {
                return api.handleStatus(response, dispatch)
            })
            .then(json => {
                    // We can dispatch many times!
                    // Here, we update the app state with the results of the API call.
                    dispatch(requestDocumentStorageSuccess(json));

                    // After copy we redirect to the configurator
                    // TODO ... check/optimize this, i think its not the best place to redirect from actions
                    if (redirectToConfigurator) {
                        const redirectUrl = '/configurator/' + json.documentId + '/' + json.id + '/0';
                        dispatch(push(redirectUrl));
                    }
                }
            )
        // .catch(error => {
        //     console.log(`Request failed: ${error}`);
        // })
        ;
    };
}

export function updateDocumentStorage(storageId, title = null, documentId = null, documentValues = null, memo=null, authorId=null) {

    return (dispatch, getState) => {

        dispatch(requestDocumentStorage());

        api.updateDocumentStorage(storageId, title, documentId, documentValues, memo, authorId)
            .then(function(response) {
                return api.handleStatus(response, dispatch)
            })
            .then(json =>
                // We can dispatch many times!
                // Here, we update the app state with the results of the API call.
                dispatch(requestDocumentStorageSuccess(json))
            )
        // .catch(error => {
        //     console.log(`Request failed: ${error}`);
        // })
        ;
    };
}

export function copyDocumentStorage(storageId, title, locale, redirectToConfigurator = false) {

    return (dispatch, getState) => {

        dispatch(requestDocumentStorage());

        api.copyDocumentStorage(storageId, title, locale)
            .then(function(response) {
                return api.handleStatus(response, dispatch)
            })
            .then(json => {
                    // We can dispatch many times!
                    // Here, we update the app state with the results of the API call.
                    dispatch(requestDocumentStorageSuccess(json));
                    // After copy we redirect to the configurator
                    // TODO ... check/optimize this, i think its not the best place to redirect from actions
                    if (redirectToConfigurator) {
                        const redirectUrl = '/configurator/' + json.documentId + '/' + json.id + '/0/1';
                        dispatch(push(redirectUrl));
                    }
                }
            )
        // .catch(error => {
        //     console.log(`Request failed: ${error}`);
        // })
        ;
    };
}

export function deleteDocumentStorage(id) {

    return (dispatch, getState) => {

        dispatch(requestDeleteDocumentStorage());

        api.deleteDocumentStorage(id)
            .then(function(response) {
                return api.handleStatus(response, dispatch)
            })
            .then(json => {
                // We can dispatch many times!
                // Here, we update the app state with the results of the API call.
                dispatch(requestDeleteDocumentStorageSuccess(id));
            })
        // .catch(error => {
        //     console.log(`Request failed: ${error}`);
        // })
        ;
    };
}

function requestDocumentStorage() {
    return {
        type: ActionType.REQUEST_DOCUMENT_STORAGE
    }
}

function requestDocumentStorageSuccess(json) {
    return {
        type: ActionType.REQUEST_DOCUMENT_STORAGE_SUCCESS,
        payload: json
    }
}

function requestDeleteDocumentStorage() {
    return {
        type: ActionType.DELETE_DOCUMENT_STORAGE
    }
}

function requestDeleteDocumentStorageSuccess(id) {
    return {
        type: ActionType.DELETE_DOCUMENT_STORAGE_SUCCESS,
        id: id
    }
}



// WEBPACK FOOTER //
// ./src/js/actions/documentStorage.js